import SidebarHeader from './SidebarHeader'
import SidebarMenu from './SidebarMenu'

interface IProps {
  visibility: boolean
  closeSidebar: () => void
}

const Sidebar = (props: IProps) => {
  return (
    <div className={props.visibility ? 'sidebar' : 'sidebar sidebar--hidden'}>
      <div onClick={props.closeSidebar} className="sidebar__overlay"></div>
      <div className="flex flex-col sidebar__container">
        <SidebarHeader />
        <SidebarMenu closeSidebar={props.closeSidebar} />
      </div>
    </div>
  )
}

export default Sidebar
